import Component from '@glimmer/component';

import BarLoaderComponent from 'webapp/components/bar-loader';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import LoaderSvgComponent from 'webapp/components/loader-svg';

import type { Goal } from 'webapp/models-custom/index';

interface Args {
	model: Goal;
}

export default class ClientGoalComponent extends Component<Args> {
	get goalData() {
		// will be always available bcos goal is saved
		return this.args.model.primaryDataModel!;
	}

	get isLoading(): boolean {
		const goalData = this.goalData;
		return !goalData || goalData.isLoadingData;
	}
	<template>
		<li class="goal" data-id={{@model.id}}>
			<div class="ct {{if this.isLoading 'no-data' 'has-data'}}">
				{{#if this.isLoading}}
					<BarLoaderComponent />
				{{else}}
					<div class="data">
						<div class="metric">
							<strong>{{@model.title}}</strong>
						</div>
						<div class="val">
							{{#if this.goalData.comparePoint.hasValue}}
								{{this.goalData.comparePoint.changeStr}}
							{{else if this.goalData.isSyncing}}
								<LoaderSvgComponent />
							{{else}}
								-
							{{/if}}
						</div>
						<div class="val2">{{this.goalData.primaryPoint.valueStr}}</div>
						{{#if this.goalData.comparePoint.hasValue}}
							<div class="val3">
								<CommonUiIconComponent @name="Target" @size="xs" />
								{{this.goalData.comparePoint.valueStr}}
							</div>
						{{/if}}
						<div class="bar">
							<em
								class={{this.goalData.currentProgressClass}}
								style={{this.goalData.currentProgressStyle}}
							></em>
						</div>
					</div>
				{{/if}}
			</div>
		</li>
	</template>
}
